<template>
  <div class="index-home">
    <Banners />
    <div class="container">
      <DashbordHighlights />
      <!-- <MapsComponents/> -->
      <Informasiterbaru />
      <!-- <div v-if="node_env != 'production'">
        <DashboardTopikPopulers/>
      </div> -->
      <DashboardSatudata />
      <Tantanganjakarta />
      <InsightJakarta />
      <JadwalRilis />
    </div>

    <div
    v-if="isModalVisible"
    class="modal fade show bd-example-modal-lg"
    id="showImagePopupModal"
    data-bs-backdrop="true"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="showImageLabel"
    style="display: block"
    aria-modal="true"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <button
            type="button"
            class="btn-close-above"
            @click="closeModal"
            aria-label="Close"
            data-dismiss="modal" 
        >
        <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <div class="modal-body text-center">
          <a title="Buka Tautan" :href="this.popupLink" target="_blank">
            <img
              :src="popupImagePath"
              alt=""
              class="img-fluid"
              @click="handleBannerClick"
              :style="{ cursor: isValidURL ? 'pointer' : 'default', color: '#3333333' }"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isModalVisible" class="modal-backdrop fade show"></div>
  
  </div>
  
</template>


<script>
import Banners from "../../components/Banners.vue";
// import DashboardTopikPopulers from '../../components/DashboardTopikPopulers.vue'
import DashbordHighlights from "../../components/DashbordHighlights.vue";
import Tantanganjakarta from "../../components/TantanganJakarta.vue";
import InsightJakarta from "../../components/InsightJakarta.vue";
import Informasiterbaru from "../../components/Informasiterbaru.vue";
import JadwalRilis from "../../components/JadwalRilis.vue";
import DashboardSatudata from "../../components/DashboardSatudata.vue";
import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";
// import MapsComponents from '../../components/MapsComponents.vue'

import axios from "axios";

//console.log(process.env)

export default {
  name: "IndexHome",
  components: {
    Banners,
    // DashboardTopikPopulers,
    DashbordHighlights,
    Tantanganjakarta,
    InsightJakarta,
    Informasiterbaru,
    JadwalRilis,
    DashboardSatudata,
    // MapsComponents
  },
  data() {
    return {
      node_env: process.env.NODE_ENV,
      isModalVisible: false,
      baseApi: this.$store.state.apiUrl,
    };
  },
  mounted() {
    axios
      .get(`${this.baseApi}/api/v2/satudata/banner-popup`)
      .then((response) => {
        if (
          response.data &&
          response.data.popup &&
          response.data.popup.image_path
        ) {
          this.popupImagePath =
            this.baseApi + "/" + response.data.popup.image_path;

          const popupLink = response.data.popup.link;
          if (popupLink && this.isValidURL(popupLink)) {
            // jika link valid
            this.popupLink = popupLink;
          } else {
            this.popupLink = null;
          }

          this.isModalVisible = true;
        } else {
          this.isModalVisible = false;
        }
      })
      .catch((error) => {
        console.error("There was an error fetching the image:", error);
        this.isModalVisible = false;
      });
  },
  methods: {
    closeModal() {
      this.isModalVisible = false;
    },
    isValidURL(url) {
      try {
        const parsed = new URL(url);
        return ["http:", "https:"].includes(parsed.protocol);
      } catch (error) {
        return false;
      }
    },
    handleBannerClick() {
      if (this.isValidURL) {
        window.open(this.popupLink, "_blank");
      } else {
        console.log("Invalid link, no action taken.");
      }
    },
  },
  setup() {
    const siteData = reactive({
      title: `Home || Satudata Jakarta`,
      description: `Portal Satudata Jakarta`,
      keyword: `satudata, satudata jakarta, satudata indonesia, satu data, open data, open data jakarta, satu data indonesia, sdi, satu data jakarta, sdj, dinas komunikasi informatika dan statistik provinsi dki jakarta, diskominfotik jakarta, data jakarta, dki jakarta, jakarta, statistik, statistik jakarta, data statistik jakarta, statistik dki jakarta, download data jakarta, unduh data jakarta, tabel data jakarta, pemprov dki jakarta, pemprov dki, cek data jakarta, diskominfo, diskominfotik dki jakarta, diskominfo dki, data jakarta, statistik jakarta, statistik data jakarta, sdj, data statistika, statistik, jakarta data, jakarta dalam angka`,
      robots: `index, follow`,
      viewport: `width=device-width, initial-scale=1.0`,
      googlebot: `index, follow`,
      site_name: `Satudata Jakarta`,
      image: window.location.origin + "/img/logo-dark.96186bab.png",
      image_type: `image/jpeg`,
      url: window.location.href,
      type: `website`,
    });
    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
      meta: [
        {
          name: `keywords`,
          content: computed(() => siteData.keyword),
        },
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `robots`,
          content: computed(() => siteData.robots),
        },
        {
          name: `viewport`,
          content: computed(() => siteData.viewport),
        },
        {
          name: `googlebot`,
          content: computed(() => siteData.googlebot),
        },
        {
          name: `og:site_name`,
          content: computed(() => siteData.site_name),
        },
        {
          name: `og:title`,
          content: computed(() => siteData.title),
        },
        {
          name: `og:description`,
          content: computed(() => siteData.description),
        },
        {
          name: `og:image`,
          content: computed(() => siteData.image),
        },
        {
          name: `og:image:type`,
          content: computed(() => siteData.image_type),
        },
        {
          name: `og:url`,
          content: computed(() => siteData.url),
        },
        {
          name: `type`,
          content: computed(() => siteData.type),
        },
      ],
      script: [
        {
          innerHTML:
            `var _paq = window._paq = window._paq || [];
              /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
              _paq.push(['trackPageView']);
              _paq.push(['enableLinkTracking']);
              (function() {
                var u="` +
            process.env.VUE_APP_MATOMO_URL +
            `"
                _paq.push(['setTrackerUrl', u+'matomo.php']);
                _paq.push(['setSiteId', ` +
            process.env.VUE_APP_MATOMO_SITE_ID +
            `]);
                var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
              })();`,
        },
      ],
    });
  },
};
</script>

<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Backdrop gelap */
  z-index: 1040;
}

.modal {
  z-index: 1050;
  /* Modal berada di atas backdrop */
}
</style>
